import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import categories from './categories'
import tags from './tags'
/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/blog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::index
* @see app/Http/Controllers/Admin/Blog/BlogController.php:24
* @route '/blog'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::bulkAction
* @see app/Http/Controllers/Admin/Blog/BlogController.php:205
* @route '/blog'
*/
export const bulkAction = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkAction.url(options),
    method: 'post',
})

bulkAction.definition = {
    methods: ["post"],
    url: '/blog',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::bulkAction
* @see app/Http/Controllers/Admin/Blog/BlogController.php:205
* @route '/blog'
*/
bulkAction.url = (options?: RouteQueryOptions) => {
    return bulkAction.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::bulkAction
* @see app/Http/Controllers/Admin/Blog/BlogController.php:205
* @route '/blog'
*/
bulkAction.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkAction.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::bulkAction
* @see app/Http/Controllers/Admin/Blog/BlogController.php:205
* @route '/blog'
*/
const bulkActionForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkAction.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::bulkAction
* @see app/Http/Controllers/Admin/Blog/BlogController.php:205
* @route '/blog'
*/
bulkActionForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkAction.url(options),
    method: 'post',
})

bulkAction.form = bulkActionForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/blog/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::create
* @see app/Http/Controllers/Admin/Blog/BlogController.php:64
* @route '/blog/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::store
* @see app/Http/Controllers/Admin/Blog/BlogController.php:75
* @route '/blog/store'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/blog/store',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::store
* @see app/Http/Controllers/Admin/Blog/BlogController.php:75
* @route '/blog/store'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::store
* @see app/Http/Controllers/Admin/Blog/BlogController.php:75
* @route '/blog/store'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::store
* @see app/Http/Controllers/Admin/Blog/BlogController.php:75
* @route '/blog/store'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::store
* @see app/Http/Controllers/Admin/Blog/BlogController.php:75
* @route '/blog/store'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
export const edit = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/blog/{blog}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
edit.url = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { blog: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { blog: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            blog: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        blog: typeof args.blog === 'object'
        ? args.blog.id
        : args.blog,
    }

    return edit.definition.url
            .replace('{blog}', parsedArgs.blog.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
edit.get = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
edit.head = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
const editForm = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
editForm.get = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::edit
* @see app/Http/Controllers/Admin/Blog/BlogController.php:131
* @route '/blog/{blog}/edit'
*/
editForm.head = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::update
* @see app/Http/Controllers/Admin/Blog/BlogController.php:145
* @route '/blog/{blog}'
*/
export const update = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/blog/{blog}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::update
* @see app/Http/Controllers/Admin/Blog/BlogController.php:145
* @route '/blog/{blog}'
*/
update.url = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { blog: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { blog: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            blog: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        blog: typeof args.blog === 'object'
        ? args.blog.id
        : args.blog,
    }

    return update.definition.url
            .replace('{blog}', parsedArgs.blog.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::update
* @see app/Http/Controllers/Admin/Blog/BlogController.php:145
* @route '/blog/{blog}'
*/
update.put = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::update
* @see app/Http/Controllers/Admin/Blog/BlogController.php:145
* @route '/blog/{blog}'
*/
const updateForm = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::update
* @see app/Http/Controllers/Admin/Blog/BlogController.php:145
* @route '/blog/{blog}'
*/
updateForm.put = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::destroy
* @see app/Http/Controllers/Admin/Blog/BlogController.php:236
* @route '/blog/{blog}'
*/
export const destroy = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/blog/{blog}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::destroy
* @see app/Http/Controllers/Admin/Blog/BlogController.php:236
* @route '/blog/{blog}'
*/
destroy.url = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { blog: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { blog: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            blog: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        blog: typeof args.blog === 'object'
        ? args.blog.id
        : args.blog,
    }

    return destroy.definition.url
            .replace('{blog}', parsedArgs.blog.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::destroy
* @see app/Http/Controllers/Admin/Blog/BlogController.php:236
* @route '/blog/{blog}'
*/
destroy.delete = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::destroy
* @see app/Http/Controllers/Admin/Blog/BlogController.php:236
* @route '/blog/{blog}'
*/
const destroyForm = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Blog\BlogController::destroy
* @see app/Http/Controllers/Admin/Blog/BlogController.php:236
* @route '/blog/{blog}'
*/
destroyForm.delete = (args: { blog: number | { id: number } } | [blog: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const blog = {
    index: Object.assign(index, index),
    categories: Object.assign(categories, categories),
    tags: Object.assign(tags, tags),
    bulkAction: Object.assign(bulkAction, bulkAction),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default blog